import styled, { css } from 'styled-components';
import { FooterHeight } from '../../../const';
import { Container } from '../../../ui/gridSystem';
import PublicPageComponent from '../../../ui/components/PublicPageComponent';

const NavBarHeight = 80;

export const Navbar = styled.nav.withConfig({
  shouldForwardProp: (prop) => !['bgHeader'].includes(prop),
})`
  height: ${NavBarHeight}px;
  background-color: ${({ theme }) => theme.colors.bgHeader};
  color: ${({ theme }) => theme.colors.white};
  position: fixed;
  top: 0;
  width: var(--full-width);
  z-index: ${({ theme }) => theme.zIndex.headerFooter};
`;
export const NavbarContainer = styled(Container)`
  display: flex;
  align-items: center;
  gap: 20px;
  height: inherit;
  width: 100%;

  & > div:first-child {
    margin-right: 30px;
  }

  & a {
    position: relative;
    height: inherit;
    display: flex;
    align-items: center;

    & > div {
      text-transform: uppercase;
      font-weight: 600;
    }
  }

  & > *:last-child {
    margin-left: auto;
    max-width: 140px;
  }
`;

export const CustomLink = styled.a`
  &:hover,
  &:active {
    text-decoration: underline;
  }

  ${(props) =>
    props.isActive &&
    css`
      &:after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: -10px;
        background-color: ${props.theme.colors.white};
        height: 4px;
        width: calc(100% + 20px);
      }
    `};
`;

export const Title = styled.div`
  padding: 30px 0 10px;
`;

export const Section = styled.div.withConfig({
  shouldForwardProp: (prop) => !['type', 'index'].includes(prop),
})`
  padding: 30px 0 50px;
  ${({ type }) =>
    type === PublicPageComponent.TYPES.ARTICLE &&
    css`
      background: linear-gradient(
        81.86deg,
        rgba(13, 69, 135, 0.122) -2.96%,
        rgba(0, 71, 146, 0) 108.78%
      );
      &.square_image {
        background: white;
      }
    `};
  ${({ type }) =>
    (type === PublicPageComponent.TYPES.NEWS ||
      type === PublicPageComponent.TYPES.LOGO ||
      type === PublicPageComponent.TYPES.STATISTICS) &&
    css`
      padding: 0;
    `}
`;

export const Footer = styled.footer`
  height: ${FooterHeight}px;
  background-color: ${({ theme }) => theme.colors.bgFooter};
  color: ${({ theme }) => theme.colors.white};
  width: var(--full-width);
  padding: 40px 0;
`;

export const FooterLinks = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
